import { render, staticRenderFns } from "./OrganizationLogoEditCard.vue?vue&type=template&id=a48c966a&"
import script from "./OrganizationLogoEditCard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationLogoEditCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports